import './assets/base/_base.scss';

import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import routes from './router/routes';
import { applyTheme } from './themes';

momentDurationFormatSetup(moment);

// Apply the stored theme synchronously before first paint to avoid a flash of
// an unthemed body. ThemeModeProvider is the source of truth thereafter and
// re-applies idempotently on mount; applyTheme reads/remaps localStorage.
applyTheme(localStorage.getItem('app-theme') ?? '');

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={routes} />);
